import '@hotwired/turbo-rails';
import { start } from '@rails/activestorage';
import { registerControllers } from 'stimulus-vite-helpers';

import '../components/generic/sidebar_layout_component';
import { application } from '../controllers/application';
import '../globals/break-frames';
import '../globals/turbo-stream-actions';

start();

const controllers = import.meta.glob(
  [
    '../../components/**/*.{js,jsx,ts,tsx}',
    '../controllers/**/*_controller.{js,jsx,ts,tsx}',
  ],
  { eager: true },
);
registerControllers(application, controllers);
